<script>
    import { createEventDispatcher } from 'svelte';
    import { uiText } from '../lib/uiText.js';
    import {
        doc,
        collection,
        addDoc,
        setDoc,
        getDoc,
        updateDoc,
        arrayUnion,
        onSnapshot,
        deleteField,
        serverTimestamp,
        increment,
        query,
        limit,
        orderBy,
    } from 'firebase/firestore';
    import OrderView from './OrderView.svelte';

    const dispatch = createEventDispatcher();

    // export let auth;
    export let db;
    export let lang;
    export let loader;
    let ui = uiText(lang);
    $: lang, (ui = uiText(lang)), dispatch('setLang', { lang: lang, prefset: true });
    $: loader, dispatch('loader', loader), (ui = uiText(lang));

    let orders = [];
    let perPage = localStorage.getItem('nPerPage') === null ? 10 : localStorage.getItem('nPerPage');
    $: perPage, () => localStorage.setItem('nPerPage', perPage), loadOrders();

    function loadOrders() {
        const q = query(collection(db, 'orders'), limit(perPage), orderBy('timeOfOrder', 'desc'));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            let querySet = [];
            querySnapshot.forEach((doc) => {
                querySet.push(doc.data());
            });
            orders = querySet;
        });
    }
    loadOrders();
</script>

<!--  -->
<!--  -->
<!--  -->
<p class="mt-6 uppercase">VG Panel</p>
<h1>Latest Orders</h1>

<div class="flex flex-wrap gap-6 my-6">
    {#each orders as order}
        <OrderView {order} />
    {/each}
</div>

<select
    name="nPerPage"
    id="nPerPage"
    bind:value={perPage}
    on:change={(perPage = perPage)}
    class="p-4"
    placeholder="10"
>
    <option value="10">10</option>
    <option value="15">15</option>
    <option value="20">20</option>
    <option value="30">30</option>
    <option value="50">50</option>
</select>
